<template>
	<sideNav :page-title="pageTitle"></sideNav>
	<div class="ld-panel-title">
		<router-link to="/account/index" class="back-btn"><span></span>{{titleText}}</router-link>
	</div>
	<div class="ld-panel-main">
		<div v-if="!checkToken"><code-verification :secver-type="secverType" @tokenChange="getToken" /></div>
		<div v-else>
			<el-card class="box-card" v-if="secverType == 'bindingweixin'">
			    <template #header>
			      <div class="card-header">
			        <span>扫描二维码完成绑定:</span>
			      </div>
			    </template>
				<div class="main">
					<div><el-image :src="'data:image/png;base64,'+wxImg"></el-image></div>
					<el-button type="primary" @click="weixinbindSave" style="margin-top: 30px;">我已扫描</el-button>
				</div>
			</el-card>
		</div>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import { weixinFetch,weixinbind,unbindingwechat } from '@/api/account';
	import sideNav from '../../components/sideNav.vue';
	import codeVerification from '../../components/codeVerification.vue';
	import { ElMessage, ElMessageBox } from 'element-plus';
	
	
	const router = useRouter();
	const pageTitle = 'account';
	const authWay = ref('');
	const checkToken = ref(false);
	const wxImg = ref('');
	const action = ref('');
	const secverType = ref('bindingweixin');
	const titleText = ref('微信绑定');
	
	const getToken = (token,way) =>{
		checkToken.value = token;
		authWay.value = way;
		if (action.value == undefined || action.value == '') {
			weixinbindF()
		}else{
			unbindingwechatF()
		}
	};
	const weixinbindF = () => {
		const param = {'way':authWay.value}
		weixinFetch(param).then((res) => {
			if (res.code == 200) {
				wxImg.value = res.data;
			}
		})
	}
	const unbindingwechatF = () => {
		const param = {'way':authWay.value}
		unbindingwechat(param).then((res) => {
			if (res.code == 200) {
				ElMessage({
					offset:70,
					message: res.msg,
					type: 'success'
				})
				router.back();
			}
		})
	}
	const weixinbindSave = () =>{
		weixinbind().then((res) => {
			if (res.code == 200) {
				ElMessage({
					offset:70,
					message: res.msg,
					type: 'success'
				})
				router.back();
			}
		})
	}

	onMounted(() => {
		if(router.currentRoute.value.query.action){
			action.value = router.currentRoute.value.query.action;
			secverType.value = 'unbindingweixin';
			titleText.value = '微信解绑'
		}
	});
	
</script>

<style>
</style>